/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Click_Drag_Create_EventsInputs */

const en_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click-n-Drag to Create Events`)
};

const fr_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquer-glisser pour créer des événements`)
};

const de_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse per Drag & Drop erstellen`)
};

const it_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai clic e trascina per creare eventi`)
};

const ru_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание событий с помощью перетаскивания мышью.`)
};

const es_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic y arrastre para crear eventos`)
};

const zh_cn2_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击并拖动即可创建事件`)
};

const ja_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリック＆ドラッグでイベントを作成`)
};

const hi_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट बनाने के लिए क्लिक करें और ड्रैग करें`)
};

const pt_pt2_options_editor_click_drag_create_events = /** @type {(inputs: Options_Editor_Click_Drag_Create_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique e arraste para criar eventos`)
};

/**
* | output |
* | --- |
* | "Click-n-Drag to Create Events" |
*
* @param {Options_Editor_Click_Drag_Create_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_click_drag_create_events = /** @type {((inputs?: Options_Editor_Click_Drag_Create_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Click_Drag_Create_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_click_drag_create_events(inputs)
	if (locale === "de") return de_options_editor_click_drag_create_events(inputs)
	if (locale === "it") return it_options_editor_click_drag_create_events(inputs)
	if (locale === "ru") return ru_options_editor_click_drag_create_events(inputs)
	if (locale === "es") return es_options_editor_click_drag_create_events(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_click_drag_create_events(inputs)
	if (locale === "ja") return ja_options_editor_click_drag_create_events(inputs)
	if (locale === "hi") return hi_options_editor_click_drag_create_events(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_click_drag_create_events(inputs)
	return en_options_editor_click_drag_create_events(inputs)
});